'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FillStyle = require('./FillStyle.js');
var _const = require('../const.js');

class LineStyle extends FillStyle.FillStyle {
  constructor() {
    super(...arguments);
    this.width = 0;
    this.alignment = 0.5;
    this.native = false;
    this.cap = _const.LINE_CAP.BUTT;
    this.join = _const.LINE_JOIN.MITER;
    this.miterLimit = 10;
  }
  clone() {
    const obj = new LineStyle();
    obj.color = this.color;
    obj.alpha = this.alpha;
    obj.texture = this.texture;
    obj.matrix = this.matrix;
    obj.visible = this.visible;
    obj.width = this.width;
    obj.alignment = this.alignment;
    obj.native = this.native;
    obj.cap = this.cap;
    obj.join = this.join;
    obj.miterLimit = this.miterLimit;
    return obj;
  }
  reset() {
    super.reset();
    this.color = 0;
    this.alignment = 0.5;
    this.width = 0;
    this.native = false;
  }
}

exports.LineStyle = LineStyle;
//# sourceMappingURL=LineStyle.js.map
